/*globals PerfectScrollbar*/

import { observable_component } from 'common/util/ComponentDecorator';

@observable_component
export default class jsScrollbar {
	static classname = 'js-scrollbar';

	constructor($scrollbar) {
		this.$scrollbar = $scrollbar;

		this.init();
	}

	init() {
		if (!this.$scrollbar.hasClass('ps')) {
			new PerfectScrollbar(this.$scrollbar[0]);
		}

		if (this.$scrollbar.hasClass('ps--active-x')) {
			this.$scrollbar.parent().addClass('overflow');
		}

		this.$scrollbar.on('ps-scroll-right', () => {
			this.$scrollbar.parent().addClass('scrolling');
		});

		this.$scrollbar.on('ps-x-reach-end', () => {
			this.$scrollbar.parent().addClass('reached-end');
		});

		this.$scrollbar.on('ps-scroll-left', () => {
			this.$scrollbar.parent().removeClass('reached-end');
		});

		this.$scrollbar.on('ps-x-reach-start', () => {
			this.$scrollbar.parent().removeClass('scrolling');
		});
	}
}
